import { httpCreate } from './http';
import conf from '@/config';

const http = httpCreate(conf.apipath + '/import');

export const importObj = {
	// 获取上传token
	options(file) {
		return http.post('/option', file);
	},
};
